import { render, staticRenderFns } from "./moderationUser.vue?vue&type=template&id=3e5a849a&scoped=true&"
import script from "./moderationUser.vue?vue&type=script&lang=js&"
export * from "./moderationUser.vue?vue&type=script&lang=js&"
import style0 from "./moderationUser.vue?vue&type=style&index=0&id=3e5a849a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5a849a",
  null
  
)

export default component.exports